import { plainToInstance, Transform, Type } from 'class-transformer'
import { IsArray, IsNotEmpty, IsNumber, IsOptional, IsString, Matches } from 'class-validator'
import 'reflect-metadata'
import { GenericEntityWithRegion, GenericEntityWithTranslation } from './generic-entity'
import { SaveTranslation } from './translation'

export class Country {
  id?: number
  isoCode?: string | null
  name: string | undefined
  translations: GenericEntityWithTranslation[] | undefined
  regions: GenericEntityWithRegion[] | undefined

  constructor(country?: Country) {
    this.id = country?.id
    this.isoCode = country?.isoCode
    this.name = country?.name
    this.translations = country?.translations
    this.regions = country?.regions
  }
}

export class SaveCountry {
  public static build(raw: any) {
    return plainToInstance(SaveCountry, raw)
  }

  @IsNumber()
  @IsOptional()
  id?: number

  @IsString()
  @IsNotEmpty()
  name!: string

  @IsOptional()
  @IsString()
  @Matches(/^[A-Z]{2}$/)
  @Transform(({ value }: { value: unknown }) => (typeof value === 'string' ? value.trim().toUpperCase() : value))
  isoCode?: string | null

  @IsArray()
  @IsOptional()
  @IsNumber({}, { each: true })
  regionIds?: number[]

  @IsNotEmpty()
  @Type(() => SaveTranslation)
  translations!: SaveTranslation[]
}
